module.exports = __webpack_public_path__ + "img/RGS.c73e6ddd.png";